import dayjs, { Dayjs } from 'dayjs'

export const getDayLabel = (date?: string | Date | Dayjs | null): string => {
    if (!date) return ''

    const d = dayjs(date)

    if (!d.isValid()) return ''

    if (d.isSame(dayjs(), 'day')) return 'Сьогодні'
    if (d.isSame(dayjs().subtract(1, 'day'), 'day')) return 'Вчора'

    return d.format('DD.MM.YYYY')
}
